module.exports = __webpack_public_path__ + "pstatic/img/13.23f53571.png";